import { render, staticRenderFns } from "./bom-match.vue?vue&type=template&id=87556936&scoped=true"
import script from "./bom-match.vue?vue&type=script&lang=js"
export * from "./bom-match.vue?vue&type=script&lang=js"
import style0 from "./bom-match.vue?vue&type=style&index=0&id=87556936&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87556936",
  null
  
)

export default component.exports